import axios from "~/plugins/axios";

export default {
  find(attachableCategoryId, includes = [], page = 1, perPage = 15, orderBy = "created_at", order = "asc") {
    return axios.get(`/web_api/v1/attachable_category/${attachableCategoryId}`, {
      params: {
        include: includes,
        page,
        perPage,
        orderBy,
        order,
      },
    }).then((response) => response.data);
  },

  getForHasAttachableAndMainCategory(hasAttachableType, hasAttachableId, category) {
    return axios.post("/web_api/v1/attachable_category/by_has_attachable_and_main_category", {
      category,
      has_attachable_type: hasAttachableType,
      has_attachable_id: hasAttachableId,
    }, {
      params: {
        include: ["main_categories", "sub_categories", "sub_categories.has_attachable", "sub_categories.attachable_categories"],
      },
    }).then((response) => response.data);
  },
  getForHasAttachable(hasAttachableType, hasAttachableId) {
    return axios.post("/web_api/v1/attachable_category/by_has_attachable", {
      has_attachable_type: hasAttachableType,
      has_attachable_id: hasAttachableId,
    }, {
      params: {
        include: ["attachable_count"],
      },
    }).then((response) => response.data);
  },
  getByClass(instanceClass, instanceId) {
    return axios.post("/web_api/v1/attachable_category/by_class", {
      has_attachable_class: instanceClass,
      has_attachable_id: instanceId,
    }, {
      params: {
        include: ["attachable_count"],
      },
    }).then((response) => response.data);
  },
  getByCustomerAndCategory(customerId, category) {
    return axios.post("/web_api/v1/attachable_category/by_customer_and_category", {
      customer_id: customerId,
      category_id: category,
    }, {
      params: {
        include: ["attachable_count"],
      },
    }).then((response) => response.data);
  },
  getForHasAttachableAndCategory(hasAttachableType, hasAttachableId, category) {
    return axios.post("/web_api/v1/attachable_category/by_has_attachable_and_category", {
      category,
      has_attachable_type: hasAttachableType,
      has_attachable_id: hasAttachableId,
    }, {
      params: {
        include: ["attachable_count"],
      },
    }).then((response) => response.data);
  },

  getCategoryForCustomerByName(customerId, categoryName) {
    return axios.get(`/web_api/v1/attachable_category/default/for_customer_by_name/${customerId}/${categoryName}`)
      .then((response) => response.data);
  },

  getAllForFamilyByCustomerAndCategory(customerId, categoryId, includes = []) {
    return axios.post(
      "/web_api/v1/attachable_category/for_family_by_customer_and_category/",
      {
        customer_id: customerId,
        category_id: categoryId,
      },
      {
        params: {
          include: includes,
        },
      },
    ).then((response) => response.data);
  },

  createFromTemplate(hasAttachableType, hasAttachableId, attachableCategoryTemplateId) {
    return axios.post("/web_api/v1/attachable_category/create_by_has_attachable_and_attachable_category_template", {
      attachable_category_template_id: attachableCategoryTemplateId,
      has_attachable_type: hasAttachableType,
      has_attachable_id: hasAttachableId,
    }).then((response) => response.data);
  },

};
